import React, { useRef, useEffect, useState } from "react";

export default function RetroPong() {
  const canvasRef = useRef(null);
  const [scoreDisplay, setScoreDisplay] = useState({ player: 0, ai: 0 });
  const [playing, setPlaying] = useState(false);
  const [winner, setWinner] = useState(null);
  const MAX_SCORE = 10;

  useEffect(() => {
    if (!playing) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const W = (canvas.width = 600);
    const H = (canvas.height = 400);

    const paddleHeight = 80;
    const paddleWidth = 10;
    const ballRadius = 8;

    let playerY = H / 2 - paddleHeight / 2;
    let aiY = H / 2 - paddleHeight / 2;
    let ball = { x: W / 2, y: H / 2, vx: 4, vy: 4 };
    let keys = {};
    const score = { player: scoreDisplay.player, ai: scoreDisplay.ai };
    let isRunning = true; 

      const handleKeyDown = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault(); // blocca scroll
    keys[e.key] = true;
  };
  const handleKeyUp = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault(); // blocca scroll
    keys[e.key] = false;
  };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    function draw() {
      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, W, H);

      // rete centrale
      ctx.fillStyle = "#0f0";
      for (let i = 0; i < H; i += 20) {
        ctx.fillRect(W / 2 - 1, i, 2, 10);
      }

      // paddle player
      ctx.fillStyle = "#0f0";
      ctx.fillRect(10, playerY, paddleWidth, paddleHeight);

      // paddle AI
      ctx.fillStyle = "#f0f";
      ctx.fillRect(W - paddleWidth - 10, aiY, paddleWidth, paddleHeight);

      // palla
      ctx.fillStyle = "#fff";
      ctx.beginPath();
      ctx.arc(ball.x, ball.y, ballRadius, 0, Math.PI * 2);
      ctx.fill();

      // score
      ctx.font = "20px monospace";
      ctx.fillStyle = "#0f0";
      ctx.fillText(score.player, W / 4, 30);
      ctx.fillStyle = "#f0f";
      ctx.fillText(score.ai, (3 * W) / 4, 30);
    }

    function resetBall() {
      ball.x = W / 2;
      ball.y = H / 2;
      ball.vx = Math.random() > 0.5 ? 4 : -4;
      ball.vy = Math.random() > 0.5 ? 4 : -4;
    }

    function update() {
      // movimento player
      if (keys["ArrowUp"]) playerY -= 5;
      if (keys["ArrowDown"]) playerY += 5;
      playerY = Math.max(0, Math.min(H - paddleHeight, playerY));

      // AI semplice
      if (ball.y > aiY + paddleHeight / 2) aiY += 4;
      if (ball.y < aiY + paddleHeight / 2) aiY -= 4;
      aiY = Math.max(0, Math.min(H - paddleHeight, aiY));

      // movimento palla
      ball.x += ball.vx;
      ball.y += ball.vy;

      // collisione top/bottom
      if (ball.y - ballRadius < 0 || ball.y + ballRadius > H) ball.vy *= -1;

      // collisione paddle player
      if (
        ball.x - ballRadius < 10 + paddleWidth &&
        ball.y > playerY &&
        ball.y < playerY + paddleHeight
      ) {
        ball.vx *= -1.05;
        ball.vy *= 1.05;
      }

      // collisione paddle AI
      if (
        ball.x + ballRadius > W - paddleWidth - 10 &&
        ball.y > aiY &&
        ball.y < aiY + paddleHeight
      ) {
        ball.vx *= -1.05;
        ball.vy *= 1.05;
      }

      // punteggio
      if (ball.x < 0) {
        score.ai += 1;
        setScoreDisplay({ ...score });
        if (score.ai >= MAX_SCORE) {
          setWinner("AI");
          setPlaying(false);
        } else resetBall();
      } else if (ball.x > W) {
        score.player += 1;
        setScoreDisplay({ ...score });
        if (score.player >= MAX_SCORE) {
          setWinner("Player");
          setPlaying(false);
        } else resetBall();
      }
    }


    function gameLoop() {
      if (!isRunning) return
      update();
      draw();
      if (playing) requestAnimationFrame(gameLoop);
    }

    requestAnimationFrame(gameLoop);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      isRunning = false;
    };
  }, [playing]);

  const startGame = () => {
    setScoreDisplay({ player: 0, ai: 0 });
    setWinner(null);
    setPlaying(true);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "30px" }}>
      {/* <h2 style={{ color: "#0f0", fontFamily: "monospace" }}>Retro Pong</h2> */}

     

      {winner && (
        <div style={{ marginBottom: "20px" }}>
          <h3 style={{ color: "yellow", fontFamily: "monospace" }}>
            {winner} wins!
          </h3>
          <button
            onClick={startGame}
            style={{
              marginTop: "10px",
              padding: "10px 30px",
              fontSize: "1.2rem",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Play again
          </button>
        </div>
      )}

      <canvas
        ref={canvasRef}
        style={{
          border: "4px solid #0ff",
          imageRendering: "pixelated",
          width: "600px",
          height: "400px",
          backgroundColor: "black",
        }}
      />
       {!playing && !winner && (
          <div style={{ marginBottom: "20px" }}>
        <button
          onClick={startGame}
          style={{
            padding: "12px 40px",
            fontSize: "1.2rem",
            fontFamily: "'Press Start 2P', monospace",
            borderRadius: "4px",
            cursor: "pointer",
            backgroundColor: "#111",
            color: "#0ff",
            border: "4px solid #0ff",

            // Glow meno brillante:
            textShadow: "0 0 3px #0ff, 0 0 5px #0ff",
            boxShadow: "0 0 4px #0ff, inset 0 0 4px #0ff, 0 0 8px #0ff",

            letterSpacing: "2px",
            transition: "transform 0.1s ease-in-out",
          }}
        >
          Play
        </button>
        </div>
      )}
    
    </div>
  );
}
